<template>
    <div id="footer" style="width: 100%">
        <mu-row>
            <mu-col :span="12" :xl="9">
                <mu-row class="d-flex justify-content-between align-items-center">
                    <mu-col v-for="(brand, index) of images_footer.brands" :key="index" class="footer-logo">
                        <a :href="brand.link" target="_blank">
                            <picture>
                                <source :srcset="`${brand.src}.webp`" type="image/webp" :alt="brand.alt"
                                    :height="brand.height" :width="brand.width" />
                                <img :src="`${brand.src}.jpg`" :alt="brand.alt" :height="brand.height"
                                    />
                            </picture>
                        </a>
                    </mu-col>
                </mu-row>
            </mu-col>
            <mu-col :span="12" :xl="3" class="h-100" style="height: 100%">
                <mu-row>
                    <mu-col class="mt-5" v-for="(social_icon, index) of images_footer.social_icons"
                        :key="index">
                        <a :href="social_icon.link" target="_blank">
                            <img :src="social_icon.src" :alt="social_icon.alt" height="30" />
                        </a>
                    </mu-col>
                </mu-row>
                <mu-row>
                    <mu-col :span="6" :lg="6" :xl="6" class="px-2 my-3">
                        <a href="https://play.google.com/store/apps/details?id=com.vallartaplus.vallartaplus">
                            <img src="/images/static/badge_play_es.png" :alt="$t('alt.android')" class="img-android" />
                        </a>
                    </mu-col>
                    <mu-col :span="6" :lg="6" :xl="6" class="px-2 my-3">
                        <a href="https://apps.apple.com/mx/app/vallartaplus/id1459155307?mt=8">
                            <img src="/images/static/badge_app_es.svg" :alt="$t('alt.ios')" class="img-ios" />
                        </a>
                    </mu-col>
                </mu-row>

                <!-- <a href="https://play.google.com/store/apps/details?id=com.vallartaplus.vallartaplus" target="_blank">
                    <img src='/images/static/google-play.png' class="width-android">
                </a>
                <a href="https://itunes.apple.com/us/app/vallarta-plus/id1459155307?l=es&ls=1&mt=8" target="_blank">
                    <img src='/images/static/App_Store.svg' class="width-ios">
				</a>-->
            </mu-col>
        </mu-row>
        <mu-row justify-content="center" align-items="center">
			<mu-col span="12" lg="9">
				<mu-row class="d-flex justify-content-around align-items-center">
					<mu-col :span="6" lg="2" v-for="(info, index) in information" :key="index" class="footer-menu-txt">
						<router-link :to="info.link" custom v-slot="{ navigate }">
							<span @click="navigate" @keypress.enter="navigate" role="link" style="cursor: pointer;">{{
								info.title }}</span>
						</router-link>
					</mu-col>
				</mu-row>
			</mu-col>
			<mu-col span="12" lg="3">
				<mu-row gutter>
					<mu-col :span="6" offset="3">
						<a href="https://mejoresempresasmexicanas.com/Pages/DetalleReconocidas.aspx?value=a5c0e2a6-41ce-497b-8ead-7935650895fd" target="_blank" >
							<img src="/images/logos/Mem.png" width="100"></img>
						</a>
					</mu-col>
				</mu-row>
			</mu-col>
		</mu-row>
        <mu-row class="mt-1">
            <mu-col :span="12" class="text-center">{{ $t('copyright') }}</mu-col>
        </mu-row>
    </div>
</template>

<script>
import _GlobalHelper from '@/store/helpers/global'
import { mapGetters } from 'vuex'
//JSON
const foot = require('~/assets/json/footer.json')

export default {
	data() {
		return {
			images_footer: {
				brands: [
					{
						src: "/images/logos/tepicplus_1",
						alt: "Tepic Plus",
						link: "https://www.tepicplus.com/",
                        height: "110",
                        width: "150"
					},
					{
						src: "/images/logos/tequilaplus_1",
						alt: "Tequila Plus",
						link: "https://www.tequilaplus.com/",
                        height: "110",
                        width: "150"
					},
					{
						src: "/images/logos/gopost_1",
						alt: "Gopost",
						link: "https://www.gopost.mx/",
                        height: "60",
                        width: "210"
					},
					{
						src: "/images/logos/aztecaplus_1",
						alt: "Azteca Plus",
						link: "https://www.aztecaplus.mx/",
                        height: "150",
                        width: "200"
					},
                    {
                        src: "/images/logos/vacations_1",
                        alt: "Vacations",
                        link: "https://www.vallartaplusvacations.com/",
                        height: "90",
                        width: "130"
					}
				],
				social_icons: [
					{
						src: "/images/social_icons/facebook.png",
						alt: "Facebook Vallarta Plus",
						link: "https://www.facebook.com/vallartaplus/"
					},
					{
						src: "/images/social_icons/instagram.png",
						alt: "Instagram Vallarta Plus",
						link: "https://www.instagram.com/vallartaplus/"
					},
					{
						src: "/images/social_icons/youtube.png",
						alt: "Youtube Vallarta Plus",
						link: "https://youtu.be/12OJ88SAevg?si=umZVUbXiXWmbjmxJ"
					},
					{
						src: "/images/social_icons/x.png",
						alt: "Twitter Vallarta Plus",
						link: "https://twitter.com/vallartaplus"
					},
					{
						src: "/images/social_icons/whatsapp.png",
						alt: "Whatsapp Vallarta Plus",
						link: "https://api.whatsapp.com/send?phone=523315266794"
					},
					{
						src: "/images/social_icons/g.png",
						alt: "Ubicación en google maps",
						link: "https://www.google.com.mx/maps/place/VALLARTA+PLUS/@20.626442,-103.2905747,17z/data=!3m1!4b1!4m5!3m4!1s0x8428b39f7a23c037:0x21f9a3ea9fdef451!8m2!3d20.626442!4d-103.288386?shorturl=1"
					},
					{
						src: "/images/social_icons/tiktok.svg",
						alt: "Tiktok Vallarta Plus",
						link: "https://www.tiktok.com/@vallarta.plus"
					}
				]
			},
			information: null,
		}
	},
	computed: {
		...mapGetters({
			lang: _GlobalHelper.getters.language
		})
	},
	created() {
		this.lang == 'es' ? (this.information = foot.es.info) : (this.information = foot.en.info)
	},
	updated() {
		this.lang == 'es' ? (this.information = foot.es.info) : (this.information = foot.en.info)
	}
}
</script>
<style lang="scss">
#footer {
	background-color: black;
	text-align: center;
	padding: 2rem;
	color: white;
	right: 0;
	left: 0;
	bottom: 0px;
	position: relative;

	.footer-logo {
		float: left;
		width: 20%;
		padding: 10px 10px;
	}

        
}

@media (max-width: 1099px) {
	#footer .footer-logo {
		width: 50%;
	}

	#footer .footer-logo.social-container {
		width: 100%;
	}
}

@media (max-width: 991px) {
	#footer .footer-logo {
		width: 50%;
	}

	#footer .footer-logo.social-container {
		width: 100%;
	}
}

@media (max-width: 480px) {
	#footer .footer-logo {
		width: 50%;
	}
	#footer {
		padding: 0 0.5rem
	}
}

@media (max-width: 574px) {
	.logo {
		margin-left: 22%;
	}
	#footer {
		padding: 0 0.5rem
	}
}
@media (max-width: 320px) {
	#footer .footer-logo {
		width: 100%;
	}
	.logo {
		margin-left: 9%;
	}
	#footer {
		padding: 0 0.5rem
	}
}

#footer .footer-menu-txt {
	float: left;
	width: 86%;
	text-align: center;
	padding: 10px 10px;

	font-size: 14px;
}

#footer .footer-menu-txt a {
	color: white;
}

@media (max-width: 991px) {
	#footer .footer-menu-txt {
		width: 100%;
	}
}

@media (max-width: 480px) {
	#footer .footer-menu-txt {
		width: 100%;
	}
	#footer {
		padding: 0 0.5rem
	}
}
@media (max-width: 320px) {
	#footer .footer-menu-txt {
		width: 100%;
		margin-left: 25%;
	}
	#footer {
		padding: 0 0.5rem
	}
}

.img-android {
	width: 160px;
	height: 50px;
}
.img-ios {
	width: 160px;
	height: 50px;
}
/* Medium and small screen */
@media only screen and (max-width: 991px) {
	.img-ios,
	.img-android {
		width: 160px;
		height: 50px;
	}
}
@media only screen and (max-width: 350px) {
	.img-android {
		width: 160px;
		height: 50px;
	}
}
</style>
